module.exports = __webpack_public_path__ + "img/1board_addLogo.03510d15.svg";